import { render } from "./Laporan.vue?vue&type=template&id=2e4a49e2"
import script from "./Laporan.vue?vue&type=script&lang=js"
export * from "./Laporan.vue?vue&type=script&lang=js"

import "./Laporan.vue?vue&type=style&index=0&id=2e4a49e2&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__